export default __webpack_public_path__ + "static/chromaV-s-c8ff2b8214df11bec1a3e3d013d5e776.mp4";